import { Settings } from 'lucide-react'
import { useState } from 'react'
import { motion } from 'framer-motion'

import { RoadmapSettings } from '@/components/settings/RoadmapSettings'
import { TagsSettingsTab } from '@/components/settings/TagsSettingsTab'
import { cn } from '@/lib/utils'
import { useTranslation } from '@/hooks/useTranslation'

const RoadmapSettingsPage = () => {
	const { t } = useTranslation()
	const [activeTab, setActiveTab] = useState<'roadmap' | 'tags'>('roadmap')

	const tabs = [
		{
			id: 'roadmap' as const,
			label: t('roadmapSettingsPage.roadmap'),
		},
		{
			id: 'tags' as const,
			label: t('roadmapSettingsPage.tags'),
		},
	]

	return (
		<div className="min-h-screen dark:from-slate-900/50 dark:via-slate-900 dark:to-slate-800/50">
			<div className="p-4 md:p-8 md:max-w-6xl md:mx-auto space-y-4 md:space-y-6">
				{/* Header */}
				<div className="flex items-center gap-3">
					<div className="p-2 bg-primary/10 rounded-lg">
						<Settings className="h-5 w-5 text-primary" />
					</div>
					<div>
						<h1 className="text-xl md:text-2xl font-semibold">
							{t('roadmapSettingsPage.roadmapSettings')}
						</h1>
						<p className="text-sm md:text-base text-muted-foreground">
							{t('roadmapSettingsPage.manageRoadmapAndTags')}
						</p>
					</div>
				</div>

				{/* Tab Navigation */}
				<div className="border-b border-border -mx-4 md:mx-0 px-4 md:px-0">
					<div className="flex gap-6 md:gap-8 overflow-x-auto pb-px">
						{tabs.map((tab) => (
							<button
								key={tab.id}
								onClick={() => setActiveTab(tab.id)}
								className={cn(
									'pb-3 px-1 border-b-2 transition-colors text-sm font-medium whitespace-nowrap',
									activeTab === tab.id
										? 'border-primary text-primary'
										: 'border-transparent text-muted-foreground hover:text-foreground'
								)}>
								{tab.label}
							</button>
						))}
					</div>
				</div>

				{/* Tab Content */}
				<motion.div
					key={activeTab}
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.3 }}>
					{activeTab === 'roadmap' && <RoadmapSettings />}
					{activeTab === 'tags' && <TagsSettingsTab />}
				</motion.div>
			</div>
		</div>
	)
}

export default RoadmapSettingsPage
